<template>
  <section class="sec sec-graph bg-light" >
		<div class="bg-primary cta">
			<div class="row">
  			<div class="colxs-12 col-sm-8 col-md-8 vcenter">
  				<h3 style="margin-top: 0px;">
            <strong>Total needed today to fund a <br>pensioner’s lifetime income<sup>*</sup></strong>
          </h3>
				</div>
				<div class="colxs-12 col-sm-4 col-md-4 vcenter">
          <p class="text-center">
            <span class="price" style="margin-bottom: 5px;">
              {{format(result.totalCosts)}}
            </span>
          </p>
				</div>
			</div>
      <div class="row" style="padding-top: 50px;">
        <!-- colxs-12 col-sm-4 -->
        <div class="colxs-12 col-md-4 col-md-offset-4">
          <p style="text-align: center; color: black;">Interested in this pension offer?</p>
          <email-flow style="padding: 0px;"></email-flow>
        </div>
      </div>

		</div>
    <div>
      <article class="mb-30">
        <p style="padding: 20px;">
          <sup>*</sup>This is the cost of providing a {{result.currentAge}} year old
          {{result.gender}} from {{result.country}} with a pension, assuming
          <span v-if="result.gender == 'female'">she</span>
          <span v-else>he</span>
          retires age {{result.agePaymentsStart}}, given current life expectancy
          for someone that age in {{result.country}} ({{result.lifeExpectancy}}
          years<sup
            class="fa fa-question"
            style="font-size: 12px;"
            v-tooltip="'Life expectancy: ' + result.lifeExpectancy + ' years. <br>Data from World Health Organization'">
          </sup>). This assumes that
          <span v-if="result.gender == 'female'">she</span>
          <span v-else>he</span>
          will receive annual payments equal to
          {{format(annualPayments)}} a year from the age of {{result.agePaymentsStart}}
          to death expected at age {{result.lifeExpectancy}} .
        </p>

        <p v-if="!onAssumptionsPage" style="padding: 20px;">
          <router-link :to="{ name: 'assumptions', params: {} }">See or amend assumptions</router-link>
        </p>

        <p v-else style="padding: 20px;">
          <router-link :to="{ name: 'home', params: {} }">Back To Calculator</router-link>
        </p>
      </article>
    </div>
    <BarChart
      :data="result.breakDown"
      :total="result.totalCosts"
      :yearPaymentsStart="result.agePaymentsStart"
    />
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import accounting from 'accounting'
import annuities from '../js/annuityCalc.js'
import BarChart from './BarChart.vue'
import EmailFlow from './EmailFlow.vue'

export default {
  name: 'Results',
  components: {
    'BarChart': BarChart,
    'email-flow': EmailFlow
  },
  computed: {
    ...mapGetters([
      'result',
      'annualPayments',
      'countries',
      'selectedCurrentAge',
      'selectedAgePaymentsStart',
      'selectedCountry',
      'selectedGender'
    ]),
    onAssumptionsPage: function(){
      return this.$route.name == 'assumptions'
    }
  },
  methods:{
    format(amount){
      return accounting.formatMoney(amount, "$", 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.calc-form {
  border: 1px black solid;
  border-radius: 10px;
  background-color: white;
  /* box-shadow: 3px 6px #888888; */
  padding: 50px;
  padding-bottom: 40px;
  height: 424.74px;
  opacity: 0.8;
}

.btn-submit {
  width: 50%;
}

.form-label-left {
  text-align: left;
}

.vcenter {
    display: inline-block;
    vertical-align: middle;
    float: none;
}
</style>
